import * as React from 'react';

import { HighlightProps } from 'react-instantsearch-core';

import { styled } from '~/styled';

const StyledMark = styled.mark`
  background-color: #19639a0d;
  color: #1a649a;
  font-weight: 600;
  padding: 0.2em;
`;

export const Snippet = ({ highlight, attribute, hit }: HighlightProps) => {
  const parsedHit = highlight({
    highlightProperty: '_snippetResult',
    attribute,
    hit,
  });

  return (
    <span>
      {parsedHit.map((part, index) => {
        return part.isHighlighted ? (
          <StyledMark key={index}>{part.value}</StyledMark>
        ) : (
          <span key={index}>{part.value}</span>
        );
      })}
    </span>
  );
};

export const Highlight = ({ highlight, attribute, hit }: HighlightProps) => {
  const parsedHit = highlight({
    highlightProperty: '_highlightResult',
    attribute,
    hit,
  });

  return (
    <span>
      {parsedHit.map((part, index) => {
        return part.isHighlighted ? (
          <StyledMark key={index}>{part.value}</StyledMark>
        ) : (
          <span key={index}>{part.value}</span>
        );
      })}
    </span>
  );
};
